<template>
  <v-card-actions>
    <v-btn
      v-if="article.prev_id"
      text
      color="primary"
      @click="select_item(article.prev_id)"
    >
      <v-icon left> mdi-arrow-left-thick </v-icon>
      {{ article.next.title }}
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
      v-if="article.next_id"
      text
      color="primary"
      @click="select_item(article.next_id)"
    >
      {{ article.prev.title }}
      <v-icon right> mdi-arrow-right-thick </v-icon>
    </v-btn>
  </v-card-actions>
</template>

<script>
export default {
  name: "ArticlePagination",
  props: ["article"],
  methods: {
    select_item: function (x) {
      this.$emit("selected_item", x);
    },
  },
};
</script>
